'use client';

import { useClientConfig } from '@shared/utils';
import { useMemo } from 'react';
import { LoqateService } from './services/loqate-service';

// A hook to create a LoqateService instance with the config from context
function useLoqateService() {
  const {
    addressLookup: { apiKey, baseUrl },
    locale,
  } = useClientConfig();

  const loqateService = useMemo(() => {
    const countries = locale === 'en-AU' ? 'AU' : 'GB';
    return new LoqateService(apiKey, baseUrl, countries);
  }, [apiKey, baseUrl, locale]);

  return loqateService;
}

export { useLoqateService };
